/* eslint-disable react/jsx-no-useless-fragment */

import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';

import SimpelLinkKort from '../SimpelLinkKort/SimpelLinkKort';
import ServicetjekBranding from '../ServicetjekBranding';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import ScrollIkon from '../ScrollIkon';

import { IServicetjekHero } from './Hero.definition';

const list = {
	hidden: { opacity: 0, left: '25%' },
	show: {
		opacity: 1,
		left: 0,
		transition: {
			staggerChildren: 0.25
		}
	}
};

const item = {
	hidden: { opacity: 0 },
	show: { opacity: 1 }
};

const Hero = (props: IServicetjekHero) => {
	const { titel, hilsen, overskrift, manchet, text, ikon, links, nummer, visLinks: visLinksFraStart = false, isPDF = false } = props;
	const [visLinks] = useState(visLinksFraStart);
	const { breakpoint } = useBreakpoint('lg');
	const ismobile = breakpoint === 'xs';
	const domRef = useRef(null);

	const nextIsSection = domRef?.current?.nextSibling?.tagName === 'SECTION';

	const handleScroll = () => {
		const sideHoejde = document.documentElement.clientHeight;

		window.scrollBy({
			top: sideHoejde * 1,
			behavior: 'smooth'
		});
	};

	/*
	useEffect(() => {
		const documentPaddingTop = document.documentElement.style.paddingTop
		if (documentPaddingTop && domRef.current) {
			domRef.current.style.paddingTop = documentPaddingTop
			domRef.current.style.marginTop = `-${documentPaddingTop}`
			domRef.current.classList.add('has-header')
			const pageTitle = domRef.current.querySelector('.hero__page-title')
			if (pageTitle) {
				pageTitle.style.top = documentPaddingTop
			}

		}
	}, []);
	*/

	const renderIntro = () => React.useMemo(() => (
		<div className="mb-3">
			{ ikon && <div className="hero__ikon text-xl"><i className={ ikon } /></div> }
			{ hilsen && <h2 className="hero__manchet mb-2">{ hilsen }</h2> }
			{ overskrift && <h1 className="hero__overskrift">{ overskrift }</h1> }
			{ manchet && <h2 className="hero__manchet">{ manchet }</h2> }
			{ text && <div className={ 'hero__text text-xs' } dangerouslySetInnerHTML={ { __html: text } } /> }
		</div>
	), []);

	const handleScrollToBottom = () => {
		const alleHeroKomponenter = Array.from(document.querySelectorAll('.servicetjek-hero'));

		/** Der skal helst være flere end 1, hvis vi skal scrolle til den anden... */
		if (alleHeroKomponenter.length > 1) {
			const denSidste = Math.max(...alleHeroKomponenter.map(hero => hero.getBoundingClientRect().y));
			window.scrollBy({
				top: denSidste,
				behavior: 'smooth'
			});
		}
	};

	const renderButtons = () => React.useMemo(() => {
		const { laesMereKnapTekst, visLinksKnapTekst, omBytKnapper } = props;

		if (isPDF) {
			return null;
		}

		return (
			<div className="hero__knapper">
				{ !omBytKnapper && (
					<div>
						{ visLinksKnapTekst && !visLinks && <button className="button button--liv" id="knap_010_dim2" onClick={ handleScrollToBottom }>{ visLinksKnapTekst }</button> }
						{ laesMereKnapTekst && visLinksKnapTekst && <button className="button button--secondary" id="knap_020_dim2" onClick={ handleScroll }>{ laesMereKnapTekst }</button> }
						{ laesMereKnapTekst && !visLinksKnapTekst && <button className="button button--liv" id="knap_010_dim2" onClick={ handleScroll }>{ laesMereKnapTekst }</button> }
					</div>
				) }
				{ omBytKnapper && (
					<div>
						{ laesMereKnapTekst && visLinksKnapTekst && <button className="button button--liv" id="knap_010_dim2" onClick={ handleScroll }>{ laesMereKnapTekst }</button> }
						{ visLinksKnapTekst && !visLinks && <button className="button button--secondary" id="knap_020_dim2" onClick={ handleScrollToBottom }>{ visLinksKnapTekst }</button> }
						{ laesMereKnapTekst && !visLinksKnapTekst && <button className="button button--liv" id="knap_010_dim2" onClick={ handleScroll }>{ laesMereKnapTekst }</button> }
					</div>
				) }
			</div>
		);
	}, [visLinks]);

	const renderFootnote = () => React.useMemo(() => {
		const { fodnote } = props;

		return (
			<div>
				<p className="mt-1">{ fodnote }</p>
			</div>
		);
	}, []);


	const renderLinks = () => (
		<motion.div>
			<motion.ul
				initial="hidden"
				animate={ visLinks ? 'show' : 'hidden' }
				variants={ list }
				style={ { position: 'relative', left: '25%', width: '100%' } }

			>
				{ links && links.map(( link, index ) => (
					<motion.li key={ link.overskrift } variants={ item }>
						<SimpelLinkKort beskrivelse={ link.manchet } overskrift={ link.overskrift } link={ link.link } className="mb-1" id={ 'link_0' + (index + 2).toString() + '0_dim2' } />
					</motion.li>
				)) }
			</motion.ul>
		</motion.div>
	);

	return (
		<section
			className={ [
				'servicetjek-hero',
				'relative',
				isPDF ? 'servicetjek-hero--isPDF' : ''
			].join(' ') }
			ref={ domRef }
		>
			{ titel ? (
				<div className="hero__page-title">
					<p className="text-center">{ titel }</p>
				</div>
			)
				: null }
			{ !isPDF && (
				<ServicetjekBranding />
			) }
			<motion.div>
				<div className="f-grid">
					{ visLinks ? (
						<>
							{ !isPDF ? (
								<>
									<motion.div
										style={ { position: 'relative', left: ismobile ? 0 : '25%' } }
										animate={ { left: 0 } }
										className="col-lg-4 col-lg-shift-1 col-md-6 col-md-shift-0 col-sm-6 relative">
										<div className="center-vert">
											<div style={ { width: '100%', textAlign: 'center' } }>
												{ renderIntro() }
												{ ismobile ? null : renderButtons() }
												{ renderFootnote() }
											</div>
										</div>
									</motion.div>
									<div className="col-lg-4 col-lg-shift-2 col-md-6 col-md-shift-0 col-sm-6">
										<div className="center-vert">
											{ renderLinks() }
										</div>
									</div>
									{ ismobile && renderButtons() }
									{ renderFootnote() }
								</>
							) : (
								<div className="col-lg-8 col-lg-shift-2 col-md-12 col-sm-12 text-center">
									<div className="center-vert">
										{ renderIntro() }
										{ renderLinks() }
										{ renderFootnote() }
									</div>
								</div>
							) }
						</>
					)
						: (
							<div className="col-sm-6 col-sm-shift-0 col-lg-8 col-lg-shift-2 text-center">
								<div>
									{ renderIntro() }
									{ !isPDF && renderButtons() }
									{ renderFootnote() }
								</div>
							</div>
						) }
				</div>
			</motion.div>
			{ !isPDF && nextIsSection && <ScrollIkon id={ 'pil_0' + (nummer).toString() + '0_dim2' } scrollToEl={ domRef.current.nextSibling } /> }
		</section>
	);
};

export default Hero;